//get the proper marker urls. Webpack outputs base64 images here
const green = require("@/assets/images/vessels/green.svg");
const orange = require("@/assets/images/vessels/orange.svg");
const red = require("@/assets/images/vessels/red.svg");
const blue = require("@/assets/images/vessels/blue.svg");
const gray = require("@/assets/images/vessels/gray.svg");
const gpsUp = require("@/assets/images/vessels/previous2.png");

export enum VesselStatusIcons {
  Ok = green,
  Observe = orange,
  NotOk = red,
  BenchMarking = blue,
  notAvailable = gray,
  PreviousPosition = gpsUp
}
